import { isMonthEnd } from "../shared/dates";
import type { ProjectionRow } from "../shared/types";

/** Keep chart datasets bounded: month-end rows plus the final projection row. */
export function sampleProjectionForChart(rows: ProjectionRow[]): ProjectionRow[] {
  if (rows.length === 0) return [];
  const sampled: ProjectionRow[] = [];
  for (const row of rows) {
    const isLast = row === rows[rows.length - 1];
    if (isMonthEnd(row.date) || isLast) {
      sampled.push(row);
    }
  }
  return sampled;
}
